import '@styles/index.scss'
import * as Sentry from "@sentry/react";
import './baseline.jsx'
import * as containers from './containers/index.jsx'
import * as components from './components/components.jsx'
import {
  assignToGlobalScope,
  canUseDOM
} from './common/utils'
import {
  dataLayerDidLoad,
  mergeWithFrontendLayer
} from './common/analytics'
import { trackFirstVisit, onDomContentLoaded, setValidateConfig } from './bootstrap'

setValidateConfig()

// These globals scope assignments are required to get server-side rendering working
// Not the pretties thing
assignToGlobalScope(containers)
assignToGlobalScope(components)

// These globals are needed to provided communication between old part of application and the react stack.
// Check _gtmhead.html.erb for reference.
assignToGlobalScope({ mergeWithFrontendLayer })
assignToGlobalScope({ dataLayerDidLoad })

// Triggered when browser app is loaded
if (canUseDOM()) {
  Sentry.init({
    dsn: REACT_SENTRY_DSN,
    environment: ENV,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [[400, 421], [423, 599]],
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    denyUrls: [
      /googletagmanager\.com/,
      /google-analytics\.com/,
      /analytics\.google\.com/
    ],
    beforeSend(event, hint) {
      const error = hint.originalException;

      if (error && (error.message === 'Network Error' || error.message === 'Failed to fetch')) {
        // Check breadcrumbs for failed Google Analytics/GTM requests
        const hasBlockedAnalyticsRequest = event.breadcrumbs?.some(
          breadcrumb =>
            breadcrumb.category === 'xhr' &&
            breadcrumb.data?.url &&
            (
              breadcrumb.data.url.includes('googletagmanager.com') ||
              breadcrumb.data.url.includes('google-analytics.com') ||
              breadcrumb.data.url.includes('analytics.google.com')
            )
        );

        if (hasBlockedAnalyticsRequest) {
          return null;
        }
      }

      return event;
    },
  });

  document.addEventListener('DOMContentLoaded', () => {
    onDomContentLoaded()
  })

  trackFirstVisit()
}
